import {
    Alert,
    Box,
    CircularProgress,
    Snackbar,
} from "@mui/material";
import PropTypes from "prop-types";

const isOpen = (val) => {
    if (typeof val === "string") return val.trim().length > 0;
    return Boolean(val); // para ReactNode, null/undefined/false => fechado
};

const AvisosLoading = ({ avisoSucesso, setAvisoSucesso, avisoErro, setAvisoErro, loading }) => {

    const handleCloseAviso = (event, reason) => {
        if (reason === "clickaway") return;
        setAvisoErro("");
        setAvisoSucesso("");
    };

    const openErro = isOpen(avisoErro);
    const openSucesso = isOpen(avisoSucesso);

    return (
        <div>
            {/***************************************** AVISOS **********************************/}
            <Snackbar
                open={openSucesso}
                autoHideDuration={5000}
                onClose={handleCloseAviso}
                anchorOrigin={{ vertical: "top", horizontal: "center" }} // posição suspensa
            >
                <Alert
                    onClose={handleCloseAviso}
                    severity="success"
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {avisoSucesso}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openErro}
                autoHideDuration={5000}
                onClose={handleCloseAviso}
                anchorOrigin={{ vertical: "top", horizontal: "center" }} // posição suspensa
            >
                <Alert
                    onClose={handleCloseAviso}
                    severity="error"
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {avisoErro}
                </Alert>
            </Snackbar>
            {/***************************************** AVISOS **********************************/}

            {/***************************************** LOADING **********************************/}
            {loading && (
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(255, 255, 255, 0.6)", // opcional: fundo semi-transparente
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1300, // acima do padrão (AppBar = 1100, Drawer = 1200)
                    }}
                >
                    <CircularProgress size={60} />
                </Box>
            )}
            {/***************************************** LOADING **********************************/}
        </div>
    );
}

AvisosLoading.propTypes = {
    avisoSucesso: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    setAvisoSucesso: PropTypes.func,
    avisoErro: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    setAvisoErro: PropTypes.func,
    loading: PropTypes.bool,
};

export default AvisosLoading;
